var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.19744 2.1709C10.699 2.1709 12.1668 2.60658 13.4153 3.42284C14.6638 4.2391 15.6369 5.39928 16.2115 6.75668C16.7861 8.11407 16.9365 9.60771 16.6435 11.0487C16.3506 12.4897 15.6275 13.8134 14.5658 14.8523C13.504 15.8912 12.1513 16.5987 10.6786 16.8853C9.20586 17.1719 7.67937 17.0248 6.29212 16.4626C4.90487 15.9003 3.71917 14.9482 2.88495 13.7266C2.05073 12.5049 1.60547 11.0687 1.60547 9.59947C1.60307 7.47144 2.43983 5.42455 3.94146 3.88518",
    stroke: "#1B6BC0",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.60547 4.45619L3.94146 3.88477L4.52545 6.17048M9.19743 5.59905V10.1705L12.2342 11.6562",
    stroke: "#1B6BC0",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBlue);
export default __webpack_public_path__ + "static/media/time-blue.a3bb95325186c199d231307acbb6404f.svg";
export { ForwardRef as ReactComponent };